module.exports = __webpack_public_path__ + "img/support_train.727117a4.png";